import { forwardRef, ReactNode, ComponentPropsWithRef } from 'react'
import classnames from 'classnames'

import Status from './Status'
import Body from './Body'
import Image from './Image'

import styles from './Card.module.scss'

export interface CardProps extends ComponentPropsWithRef<'div'> {
  focused?: boolean
  slim?: boolean
  className?: string
  children: ReactNode
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ focused, slim = false, children, className }, ref) => {
    return (
      <div
        ref={ref}
        className={classnames(
          styles.listingCard,
          focused && styles.focused,
          slim && styles.slim,
          className
        )}
        tabIndex={-1}
      >
        {children}
      </div>
    )
  }
)

const cardNamespace = Object.assign(Card, { Image, Status, Body })

export { cardNamespace as Card }
